import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { customEvent } from '../../Utilities/GoogleAnalytics';

const FullLogo = 'https://res.cloudinary.com/stamped/image/upload/v1608735103/General%20Assets/stampedFull_d9ryj4.png';
const MenuIcon = 'https://res.cloudinary.com/stamped/image/upload/v1608735307/Icons/menu_fiiazw.png';
const Instagram = 'https://res.cloudinary.com/stamped/image/upload/v1608735325/SVGs/instagram_yywm4e.svg';
const Email = 'https://res.cloudinary.com/stamped/image/upload/v1608735327/SVGs/mail_k5ikwu.svg';

export default function TopBar({ affiliatePage }) {
  /** Changes or shows mobile menu */
  const [showMobileMenu, changeShowMobileMenu] = useState(false);

  /** Unique buy button that shows become and affiliate on /affiliate page */
  const BuyButton = () => (
    <a
      onClick={() => customEvent('User', 'Buy Bundle Clicked')}
      className=""
      href="https://gum.co/vZSlH?wanted=true"
      rel="noreferrer"
      target="_blank"
    >
      {affiliatePage ? (
        ''
      ) : (
        <button className="w-1/2 pt-2 pb-2 pl-5 pr-5 m-auto text-sm font-bold text-center text-white rounded-sm rounded shadow cursor-pointer bg-brandcolor font-brand">
          Buy Bundle
        </button>
      )}
    </a>
  );

  const MobileMenu = () => (
    <AnimatePresence>
      <motion.div
        animate={{ x: 0 }}
        initial={{ x: 500 }}
        exit={{ x: 500 }}
        transition={{ duration: 0.5 }}
        className="fixed top-0 z-40 w-screen h-screen bg-white lg:hidden font-brand"
      >
        <div className="flex flex-wrap pt-24 font-semibold text-center list-none shadow font-brand">
          <div className="w-1/2 text-left">
            <div className="">
              <Link to="/">
                <li className="pb-4 pl-8">Home</li>
              </Link>
              <Link to="/about">
                <li className="pb-4 pl-8">About</li>
              </Link>
              <Link to="/tools">
                <li className="pb-4 pl-8">Tools</li>
              </Link>
            </div>
          </div>
          <div className="w-1/2 text-left">
            <Link to="/reviews">
              <li className="pb-4 pr-4">Reviews</li>
            </Link>
            <Link to="/contact">
              <li className="pb-4 pr-4">Contact</li>
            </Link>
          </div>
        </div>
        <div className="h-full pt-2 bg-altBack">
          <div className="pt-12 text-center xs:pt-24">
            <h3 className="text-xl font-bold">
              <a href="https://instagram.com/stamped.wiki">
                <div className="flex items-center justify-center w-full">
                  <img className="w-6" src={Instagram} alt="Instagram" />
                  <p className="ml-2 text-left">stamped.wiki</p>
                </div>
              </a>
            </h3>
            <p className="pt-2 ml-20 mr-20 text-xs">
              Follow us on Instagram for important updates from Canada, interesting facts & exclusive community insights.
            </p>
            <br />
            <h3 className="pt-6 text-xl font-bold">
              <div className="flex items-center justify-center w-full">
                <img className="w-6" src={Email} alt="Email" />
                <p className="ml-2 text-left">want to talk?</p>
              </div>
            </h3>
            <p className="pt-2 ml-20 mr-20 text-xs">
              For affiliate inquiries, questions about the product or anything in general: send us an e-mail on support@stamped.wiki
            </p>
            <div className="pt-12 xs:p-24">
              <BuyButton />
              <p className="pt-4 text-xs text-gray-500">Limited offer $50 | Regular price $99</p>
            </div>
          </div>
        </div>
      </motion.div>
    </AnimatePresence>
  );

  const MenuItems = ({ MenuLinks }) =>
    MenuLinks.map((menuLink) => (
      <Link key={menuLink.name} to={menuLink.url}>
        <li className="pl-4 pr-4 font-normal hover:font-semibold">{menuLink.name}</li>
      </Link>
    ));

  const MenuLinks = [
    { name: 'Home', url: '/home' },
    { name: 'Tools', url: '/tools' },
    { name: 'About', url: '/about' },
    { name: 'Reviews', url: '/reviews' },
    { name: 'Contact', url: '/contact' },
  ];

  const AboveTop = () => (
    <div className="px-4 py-1 bg-brandcolor">
      <p className="text-xs font-bold text-center text-white capitalize">
        Sept'21 & Jan'22 Intake Indian Edition –{' '}
        <a
          onClick={() => customEvent('User', 'Buy Bundle Clicked')}
          className=""
          href="https://gum.co/vZSlH?wanted=true"
          rel="noreferrer"
          target="_blank"
        >
          {' '}
          <span className="transition duration-100 border-b-2"> Buy It Now </span> {' '}
        </a>
      </p>
    </div>
  );

  return (
    <>
      {showMobileMenu ? <MobileMenu /> : ''}
      <div className="fixed z-50 w-full h-auto bg-white shadow-xs">
        <AboveTop />
        <div className="flex items-center pt-3 pb-3 -mr-16 lg:pr-5 lg:pl-5">
          <div className="w-1/2 text-right lg:w-1/3">
            <Link to="/home">
              <img className="m-auto text-center" width="150px" src={FullLogo} alt="Stamped Logo" />
            </Link>
          </div>
          <div className="hidden w-1/3 text-center list-none cursor-pointer lg:flex justify-evenly font-brand">
            <MenuItems MenuLinks={MenuLinks} />
          </div>
          <div className="hidden text-center lg:block lg:w-1/3">
            <BuyButton />
          </div>
          <div className="w-1/2 text-right lg:hidden">
            <img onClick={() => changeShowMobileMenu(!showMobileMenu)} className="w-5 m-auto" src={MenuIcon} alt="Icon" />
          </div>
        </div>
      </div>
    </>
  );
}
